module.exports = __webpack_public_path__ + "img/35.c7ed826b.webp";